module.exports = __webpack_public_path__ + "static/ebr-9-def24b2cd1b4adef2ebb8830b52afab5.jpg";